// extracted by mini-css-extract-plugin
module.exports = {"label":"MultiTextInput_ketogo_label__iOfQ3","input":"MultiTextInput_ketogo_input__3ZzsN"};